import { canonicalLoomDefinitionJson } from "./loomAcceptedDefinitionBinding";
import type { LoomAcceptedMeshHeader } from "./loomAcceptedMeshContract";

function hex(bytes: Uint8Array): string {
  return Array.from(bytes, (value) => value.toString(16).padStart(2, "0")).join("");
}

export async function verifyLoomDefinitionIntegrity(
  accepted: LoomAcceptedMeshHeader,
  parameters: Record<string, unknown>,
): Promise<void> {
  const binding = accepted.definitionBinding;
  if (accepted.schema === "loom.accepted-mesh/v1") {
    if (binding || accepted.sourceReceipt || accepted.adaptationReceipts
        || parameters.definitionRevision !== undefined
        || parameters.authoritativeDefinition !== undefined) {
      throw new Error("Loom v1 accepted geometry cannot carry a versioned definition binding");
    }
    return;
  }
  if (!binding) throw new Error("Versioned Loom accepted geometry has no definition binding");
  const topology = accepted.schema === "loom.accepted-mesh/v3"
    ? "selected-wing-fuselage-pairwise-union"
    : "canonical-starboard-wing-fuselage-union";
  const canonical = new TextEncoder().encode(canonicalLoomDefinitionJson({
    definition: binding.definition, evaluatorId: binding.evaluatorId, topology,
  }));
  const digest = new Uint8Array(await crypto.subtle.digest("SHA-256", canonical));
  const definitionRevision = `sha256:${hex(digest)}`;
  if (definitionRevision !== binding.definitionRevision
      || parameters.definitionRevision !== definitionRevision
      || canonicalLoomDefinitionJson(parameters.authoritativeDefinition)
        !== canonicalLoomDefinitionJson(binding.definition)) {
    throw new Error("Loom accepted geometry definition binding is stale or forged");
  }
}
